import React, { Component } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import isEmpty from "assets/scripts/utils/isEmpty";
import validEmail from "assets/scripts/utils/validEmail";
import { ERRORS, REQUIRED } from "assets/scripts/constants/FormMessages";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import CaptchaForm from "assets/scripts/components/common/form/CaptchaForm/CaptchaForm";
const messages = defineMessages({
    button: {
        id: "login.button",
        defaultMessage: "Login"
    },
    usernameLabel: {
        id: "forms.login.username.label",
        defaultMessage: "Email address"
    },
    usernameHelp: {
        id: "forms.login.username.help",
        defaultMessage: "Must be a valid email address"
    },
    passwordLabel: {
        id: "forms.login.password.label",
        defaultMessage: "Password"
    }
});
function getErrors(value) {
    return {
        username: isEmpty(value.username) || !validEmail(value.username) ? ERRORS.EMAIL : null,
        password: value.password.length === 0 ? REQUIRED : null
    };
}
export default class LoginForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleUsernameChange = (username) => this._handleValueChange({ username });
        this._handlePasswordChange = (password) => this._handleValueChange({ password });
        this.state = {
            value: {
                username: "",
                password: "",
            }
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        const { value } = state;
        const errors = getErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<CaptchaForm isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.button} error={globalError}>
				{captcha => (<fieldset className="fieldset">
						<legend>
							<span className="u-isVisuallyHidden">
								<FormattedMessage id="forms.login.legend" defaultMessage="Your Account Info"/>
							</span>
						</legend>

						<TextFormGroup name="username" type="email" label={messages.usernameLabel} help={messages.usernameHelp} value={value.username} onChange={this._handleUsernameChange} error={errors.username} backendError={backendErrors.username} inputProps={{
            autoComplete: "username"
        }} required/>

						<TextFormGroup name="password" type="password" label={messages.passwordLabel} value={value.password} onChange={this._handlePasswordChange} error={errors.password} backendError={backendErrors.password} inputProps={{
            autoComplete: "current-password"
        }} required/>

						{captcha}
					</fieldset>)}
			</CaptchaForm>);
    }
    _handleValueChange(value) {
        this.setState(prevState => ({
            value: {
                ...prevState.value,
                ...value
            }
        }));
    }
    _handleSubmit(captcha) {
        this.props.login(this.state.value, captcha || undefined);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/LoginForm/LoginForm.tsx